/**
 * The release a client bundle was built from (stream note 17, 2026-10-08):
 * scripts/vps/deploy.sh bakes the deployed tag into VITE_RELEASE_VERSION
 * (vite.config.mjs `process.env` define). Dev and PTR builds have none.
 */
const RELEASE_TAG = /^v?\d+\.\d+\.\d+[0-9A-Za-z.+-]*$/;

/** The baked release tag ("v0.67.9"), or undefined on an untagged build. */
export function bakedReleaseVersion(raw: string | undefined = process.env.VITE_RELEASE_VERSION): string | undefined {
  const value = raw?.trim();
  if (!value || !RELEASE_TAG.test(value)) return undefined;
  return value.startsWith('v') ? value : `v${value}`;
}

/** What the room pill shows: the release tag, else the short build sha. */
export function buildLabel(shortSha: string | undefined, raw?: string): string | undefined {
  return bakedReleaseVersion(raw) ?? shortSha;
}
